import { speed } from 'src/ui/common/config/animations';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledPreviewContainer = styled.div`
    position: relative;
    overflow: hidden;
    cursor: pointer;
`;

export const StyledWave = styled.div`
    width: 1600px;
    height: 1600px;
    position: absolute;
    top: 65%;
    left: 50%;
    margin-left: calc(1500px / -2);
    background: ${({ theme }) => theme.colors.turtle};
    border-radius: 43%;
    z-index: 1;
    animation: waves 20s infinite linear;
    opacity: 0.85;

    @keyframes waves {
        from {
            transform: rotate(360deg);
        }
    }
`;

export const StyledWaveTwo = styled.div`
    width: 1000px;
    height: 1000px;
    position: absolute;
    top: 60%;
    left: 50%;
    margin-left: calc(1200px / -2);
    border-radius: 43%;
    z-index: 1;
    opacity: 0.95;
    animation: waves 30s infinite linear;
    background: ${({ theme }) => theme.colors.blue};
    @keyframes waves {
        from {
            transform: rotate(360deg);
        }
    }
`;

export const StyledWaveThree = styled.div`
    width: 1000px;
    height: 1000px;
    position: absolute;
    top: 70%;
    left: 50%;
    margin-left: calc(1500px / -2);
    border-radius: 43%;
    z-index: 1;
    opacity: 0.75;
    animation: waves 40s infinite linear;
    background: ${({ theme }) => theme.colors.purple};
    @keyframes waves {
        from {
            transform: rotate(360deg);
        }
    }
`;

export const StyledInfoBanner = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px 40px;
    width: 100%;
    z-index: 5;
`;

export const StyledInfoBannerTop = styled.div`
    color: ${({ theme }) => theme.colors.white};
    font-size: 24px;
    transition: all 0.3s;
    line-height: 40px;
    overflow: hidden;
    white-space: nowrap;
`;

export const StyledInfoBottom = styled.span`
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    color: white;

    &:before {
        content: '';
        width: 7%;
        height: 2px;
        background: ${({ theme }) => theme.colors.blue};
        position: absolute;
        bottom: 15px;
        transition: all 0.3s ease;
    }

    &:hover {
        &:before {
            width: 20%;
        }
    }
`;

export const StyledPreviewWrapper = styled.div`
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 220px;

    & img {
        max-width: 100%;
        min-height: auto;
        transition: transform ${speed.content} ease-in;
    }

    & img:hover {
        transform: scale(1.1, 1.1);
    }

    ${media.sm`
        height: 300px;
    `}

    ${media.md`
        height: 280px;
    `}
`;
